(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("loading-management", [], factory);
	else if(typeof exports === 'object')
		exports["loading-management"] = factory();
	else
		root["loading-management"] = factory();
})(this, function() {
return 